import { connect } from 'react-redux';

const mapStateToProps = state => ({
  formPostUrl: state.mainreducer.virtualFormPostUrl,
  cities: state.mainreducer.firstDropDownItems,
  formAuthToken: state.mainreducer.formAuthToken,
});

export default VirtualTourLeftPart => connect(mapStateToProps, null)(VirtualTourLeftPart);
